export default "__VITE_ASSET__afba9d56__"